module.exports = __webpack_public_path__ + "static/media/Share.fb0704e1.png";